module.exports = __webpack_public_path__ + "static/media/lovedot.27ec13bc.png";